import { useCallback } from 'react';
import { useRouter } from '@tanstack/react-router';

import {
  LINKED_ACCOUNTS_HASH,
  LINKED_ACCOUNTS_PATH,
} from '../personalAccounts';

/**
 * Opens the person's Linked accounts panel, where a refused start or a blocked
 * run sends them (spec 160). The panel scrolls itself into view on this hash
 * (spec 159).
 *
 * Read without a router where there is none (a test, a surface outside the
 * shell), as `Markdown`'s in-app links are: the page is then loaded the
 * ordinary way, because the way out must never go dead.
 */
export function useOpenLinkedAccounts(): () => void {
  const router = useRouter({ warn: false });
  return useCallback(() => {
    const href = `${LINKED_ACCOUNTS_PATH}#${LINKED_ACCOUNTS_HASH}`;
    if (!router) {
      window.location.assign(href);
      return;
    }
    router
      .navigate({ to: LINKED_ACCOUNTS_PATH, hash: LINKED_ACCOUNTS_HASH })
      .catch(() => {
        window.location.assign(href);
      });
  }, [router]);
}
